import React from "react";
import { Button, Typography, ThemeProvider } from "@mui/material";
import Modal from "../../CommonComponents/common/modal/Modal";

export default function ExitSimulationModal({ open, handleClose, onConfirm, theme }) {
  const buttonContent = (
    <>
      <Button onClick={handleClose} variant="outlined" color="primary">
        No
      </Button>
      <Button
        onClick={onConfirm}
        color="primary"
        variant="contained"
        sx={{ ml: 1 }}
      >
        Yes
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      title="Exit Simulation?"
      initialWidth={500}
      initialHeight={250}
      content={
        <Typography>
          All the changes you made will be lost. Do you want to continue?
        </Typography>
      }
      action={
        theme ? (
          <ThemeProvider theme={theme}>{buttonContent}</ThemeProvider>
        ) : (
          buttonContent
        )
      }
    />
  );
}